export default {
  'profilecredit.profilecreditreport': 'Umsatz mit Kreditkonten',
  'profilecredit.creditstatus': 'Kreditstatus',
  'profilecredit.credittotalamount': 'Gesamtbetrag des zugewiesenen Kredits',
  'profilecredit.creditremainamount':
    'Gesamtbetrag des verbleibenden Guthabens',
  'profilecredit.profilecreditreport': 'Zugeordnete Kreditauskunft',
  'profilecredit.creditamount': 'Kreditbetrag',
  'profilecredit.remaincreditamount': 'Kreditbetrag bleiben',
  'profilecredit.assigndate': 'Zugewiesenes Datum',
  'profilecredit.duration': 'Dauer(Tag)',
  'profilecredit.active': 'aktiv',
  'profilecredit.expired': 'abgelaufen',
  'profilecredit.sum': 'Summe',
  'profilecredit.expensesamount': 'ُAusgegebener Kreditbetrag',
  'profilecredit.nocredit': 'Kein Kredit',
  'profilecredit.assigncredit': 'Guthaben zuweisen',
  'profilecredit.creditamountceiling': 'Kreditbetrag Obergrenze',
  'profilecredit.deletecredit': 'Guthaben löschen',
  'profilecredit.deleteconfirmation':
    'Sind Sie sicher, dieses Guthaben zu löschen?',
  'profilecredit.fullname': 'Vollständiger Name',
  'profilecredit.expensesreport': 'Ausgabenbericht',
  'profilecredit.credit': 'Anerkennung',
  'profilecredit.mycreditmanagement': 'Mein Kreditmanagement',
  'profilecredit.creditmanagement': 'Kreditmanagement',
  'profilecredit.employeecreditmanagement':
    'Verwaltung von Mitarbeiterkrediten',
  'profilecredit.creditadd': 'Gutschrift erfolgreich hinzugefügt',
  'profilecredit.creditadderror':
    'Für dieses Profil ist bereits eine Zuordnung vorhanden',
  'profilecredit.noteligibleprofile':
    'Dieses Profil kann nicht zugeordnet werden',
  'profilecredit.downloadexcel': 'Excel-Datei herunterladen',
  'profilecredit.fromdate': 'Ab zugewiesenem Datum',
  'profilecredit.todate': 'Zu zugewiesenem Datum',
};
